<template>
    <div class="main-layout">
        <div class="layout grid">
            <div class="profile-data" @click="goToPatientDetails">
                <div class="user__avatar">
                    <common-rating-avatar :user="physician" :size="avatarSize"></common-rating-avatar>
                </div>
                <div class="visit-layout">
                    <p class="patient-name">{{ physician.firstName }} {{ physician.lastName }}</p>
                    <p v-if="physician.lastReferralCreatedDateTime" class="visit">
                        {{ $t('modals.member_card.lastvisit.title') }} {{ formattedDate }}
                    </p>
                </div>
                <span v-if="physician.lastReferralStatus" class="referral">{{ physician.lastReferralStatus }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import PhysicianMixin from 'mixins/PhysicianMixin'

    export default {
        mixins: [PhysicianMixin],
        props: {
            physician: { type: Object, required: true },
        },
        computed: {
            avatarSize() {
                switch (this.size) {
                    case 'medium':
                        return 'user-context'
                    default:
                        return 'member-switch'
                }
            },
            formattedDate() {
                return this.physician.lastReferralCreatedDateTime
                    ? dayjs(this.physician.lastReferralCreatedDateTime).format('MMMM D, YYYY')
                    : undefined
            },
        },
        methods: {
            goToPatientDetails() {
                this.$router.push(`/patients/details/patients/${this.physician.id}`)
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/patients/_patient';
</style>
